import { useEffect } from 'react';
import useRouterState from '@discover-use-router-state';
import { useStoreRehydrated } from '@discover-data/stores/restaurant/hooks';
import { useAuthState } from '@/components/context/AuthContext';
import getValidFavourite from './getValid';
import useFavourite from './useFavourite';
import FAVOURITE_QUERY_KEY from './queryKey';

/**
 * Sync the router state value to the restaurant store
 */
export default function useSyncFavourite() {
  const rehydrated = useStoreRehydrated();
  const { user, isLoggedIn } = useAuthState();
  const [storeValue, setFavourite] = useFavourite(user?.favouriteIds);
  const [{ [FAVOURITE_QUERY_KEY]: routerValues }] = useRouterState([FAVOURITE_QUERY_KEY]);
  const routerValue = getValidFavourite(routerValues);

  useEffect(() => {
    if (!rehydrated) {
      return;
    }

    // only set the value if the user is logged in
    if (!isLoggedIn) {
      // only set the value if it is different in the store, to not cause unnecessary router changes
      if (storeValue !== false) {
        setFavourite(false);
      }

      return;
    }

    if (
      // only set if the value changed
      // `storeValue` could be an array so need to be carefull when comparing values with `routerValue` (a boolean)
      (routerValue === false && storeValue !== false) ||
      (routerValue !== false && storeValue === false)
    ) {
      setFavourite(routerValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rehydrated, routerValue, isLoggedIn]); // we only care about changes to the router value and logged-in state
}
